// get markets

/* 

<script>
  const otherMarkets = "{% for country in localization.available_countries %}{{ country.iso_code }}{% unless forloop.last %},{% endunless %}{% endfor %}";
  console.log(otherMarkets); // e.g. "AU,BU,CU"
</script>

*/


// CN = China
// KP = North Korea
// MM = Myanmar
// IR = Iran
// RU = Russia
// BY = Belarus
// YE = Yemen

const blockedCountryCodes = ["CN", "KP", "MM", "IR", "RU", "BY", "YE"];

function getLocation(){
    const url = "https://api.bigdatacloud.net/data/reverse-geocode-client";
    return fetch(url)
        .then(res => res.json())
        .then(data => data);
}

class PfMarketTraker extends HTMLElement{
    constructor(){
        super();
    }

    async connectedCallback(){
        if(this.hasShownPopupToday()) return;
        
        // elements
        const popup = this;
        const closeBtn = this.querySelector(".close_btn");
        const continueBtn = this.querySelector(".continue_btn");
        const marketsOne = this.getAttribute("data-country-codes-one").split(",");
        const marketsOneUrl = this.getAttribute("data-url-one");
        const marketsTow = this.getAttribute("data-country-codes-tow").split(",");
        const marketsTowUrl = this.getAttribute("data-url-tow");

        // closer (correct)
        closeBtn.addEventListener("click", () => this.closePopup());
        continueBtn.addEventListener("click", () => this.closePopup());

        // get location
        const location = await getLocation();
        const userCountry = location.countryCode;
        
        if(blockedCountryCodes.includes(userCountry)) {
            document.body.innerHTML = `
            <div style="
                background:black;
                color:white;
                height:100vh;
                width:100%;
                display:flex;
                align-items:center;
                justify-content:center;
                font-family:sans-serif;
                font-size:48px;
            ">
                Blocked
            </div>
            `;

            return;
        }

        const matchedOne = marketsOne.includes(userCountry);
        const matchedTow = marketsTow.includes(userCountry);

        if (matchedOne) {
            // console.log("Redirect to market:", matched.storeUrl);
            this.openPopup(location.countryName, location.countryCode, marketsOneUrl);
        } else if(matchedTow){
            this.openPopup(location.countryName, location.countryCode, marketsTowUrl);
        }
    }

    openPopup(country, countryCode, url){
        const countryName = this.querySelector(".country_name");
        const storeUrl = this.querySelector(".store_url");
        const confirmBtn = this.querySelector(".confirm_button");

        countryName.innerHTML = country === "United States of America (the)" ? "United States" : country;
        storeUrl.innerHTML = countryCode + " Store";

        storeUrl.setAttribute("href", url);
        confirmBtn.setAttribute("href", url);

        localStorage.setItem("pf_market_popup_shown", new Date().toISOString());

        this.classList.add("active");
    }

    closePopup(){
        this.classList.remove("active");
    }

    hasShownPopupToday() {
        const key = "pf_market_popup_shown";
        const stored = localStorage.getItem(key);

        // If nothing stored → popup was NOT shown today
        if (!stored) return false;

        const lastShown = new Date(stored);
        const now = new Date();

        // Calculate time difference in milliseconds
        const diff = now - lastShown;

        // 1 day in milliseconds
        const oneDay = 24 * 60 * 60 * 1000;

        // Return true if shown within last 24 hours
        return diff < oneDay;
    }
}

if(!customElements.get("pf-market-traker")) {
  customElements.define("pf-market-traker", PfMarketTraker);
}
